<template>
    <div class="text" :class="{'text-truncate': !expanded}" :style="textAlignStyle">
        <slot></slot>
        <a class="text-primary cursor-pointer" @click="toggle" v-if="more_than_limit"
           :class="{'link-when-compressed': !expanded, 'ml-1': expanded}"><i class="fa-fw fa"
                                                                             :class="{'fa-angle-double-up': expanded, 'fa-angle-double-down': !expanded}"></i>{{
            expanded ? 'less' : 'more' }}</a>
    </div>
</template>

<style lang="scss" scoped>
    .text {
        position: relative;

        &.text-truncate {
            padding-right: 60px;
        }
    }

    .link-when-compressed {
        position: absolute;
        right: 0;
    }
</style>


<script>
    export default {
        props: {
            compressed: {default: true},
            limit: {default: false},
            body: {default: false},
            textAlign: {default: ''}
        },

        data() {
            return {
                expanded: !this.compressed,
            };
        },

        computed: {
            slot_content() {
                return this.$slots.default && this.$slots.default.length && this.$slots.default[0].text;
            },
            more_than_limit() {
                return this.limit ? (this.body.length >= this.limit) : true;
            },
            textAlignStyle() {
                return `text-align: ${this.textAlign}`;
            }
        },

        watch: {
            compressed() {
                this.expanded = !this.compressed;
            },
        },

        methods: {
            toggle() {
                this.expanded = !this.expanded;
                this.$emit('update:compressed', !this.expanded);
            }
        }
    };
</script>
